
import { 
  fetchJson,
  UPDATE_COUPON, 
  UPDATE_COUPON_ASYNC,
  REMOVE_COUPON,
  REMOVE_COUPON_ASYNC,
  UPDATATING_COUPON_ASYNC
} from '../../GlobalStateContainer'

import {
  notifyError
} from '../UserMessaging'

import isEqual from 'lodash/isEqual';

const onAddCouponSuccess = (responseObject, postedCouponCodeDetails) => {
    const couponCode = postedCouponCodeDetails.CouponCode;
    if(responseObject === "OK") {
    return {type: UPDATE_COUPON, couponCode};
  } else {
    return notifyError("We could not add coupon '" + couponCode + "' to your order. Please confirm you meet all requirements, and have typed it correctly.",
    responseObject);
  }
}

const AddCouponAsyncSpec = {
  endpoint: (state) => state.constants.navigation.addCouponEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: (couponCode) => ({type: UPDATE_COUPON_ASYNC, couponCode}),
  extract: (response) => response.text(),
  onSuccess: onAddCouponSuccess,
  onError: (diagMsg) => notifyError("An error occurred adding your coupon", diagMsg),
}

export const addCouponAsync = fetchJson(AddCouponAsyncSpec);

const onRemoveCouponSuccess = (responseObject) => {
  if(responseObject === "OK") {
    return {type: REMOVE_COUPON};
  } else {
    console.log(responseObject);
  }
}

const RemoveCouponAsyncSpec = {
  endpoint: (state) => state.constants.navigation.removeCouponEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify: () => ({type: REMOVE_COUPON_ASYNC}),
  extract: (response) => response.text(),
  onSuccess: onRemoveCouponSuccess,
  onError: (diagMsg) => notifyError("An error clearing your coupon", diagMsg),
}

export const removeCouponAsync = fetchJson(RemoveCouponAsyncSpec);

const updateCouponSuccess = (responseObject, data, getState) => {
  const couponCode = responseObject;
  const state = getState();
  const previousCouponCode = state.entities.CouponCode;
  if(previousCouponCode && !isEqual(couponCode, previousCouponCode)) {
    return [
      notifyError(`Your coupon code '${state.entities.CouponCode}' is no longer valid, or your order does not meet the requirements. Please try again.`), 
      { type: UPDATE_COUPON, couponCode }
    ]
  }
  return { type: UPDATE_COUPON, couponCode };
}

const updatingCouponAsync = () => ({type: UPDATATING_COUPON_ASYNC});

const updateCouponAsyncFetchSpec = {
  endpoint : state => state.constants.navigation.couponEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify   : () => updatingCouponAsync(),
  extract  : response => response.text(),
  onSuccess: updateCouponSuccess,
  onError: (diagMsg) => notifyError("An error clearing your coupon", diagMsg)
}

export const updateCouponAsync = fetchJson(updateCouponAsyncFetchSpec)


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Coupon/couponActions.js